export function request(userId) {
    return {
        type: 'BETSLIP_REJECT_REFERRED_REQUEST',
        userId
    };
}

export function error(userId, { errors }) {
    return {
        type: 'BETSLIP_REJECT_REFERRED_ERROR',
        userId,
        errors
    };
}

export function finish(userId) {
    return {
        type: 'BETSLIP_REJECT_REFERRED_FINISH',
        userId
    };
}

export function clear(userId) {
    return {
        type: 'BETSLIP_REJECT_REFERRED_CLEAR',
        userId
    };
}
